<template>
  <div id="Win" class="Page Win">
    <Shape ref="shape" />
    <div class="Page_wrapper">
      <img src="/assets/images/gouvernail.svg" alt="Gouvernail" />
      <transition name="title" appear>
        <h2>Woaaaaw !<br>A vous les Calissons du Roy Rene</h2>
      </transition>

      <transition name="content" appear>
        <p>On est des vraies canailles... des maudits pirates... <br class="desktop" />Trinquons à cette nouvelle année, yo ho yo ho !<br><br><b>Entrez le code à 4 chiffres sur le cadenas situé sur le trésor <br class="desktop"/>que vous avez peut-être reçu.</b><br><br>
        
        Amicalement,<br>
        <b>l'équipage LP5></b></p>
      </transition>

      <img class="longuevue" src="/assets/images/longuevue.svg" alt="Longue-vue" />
      <img class="ancre" src="/assets/images/ancre.svg" alt="Ancre" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import page from "@/mixins/page"

import Shape from '@/components/partial/Shape'

export default {
  components: { Shape },
  mixins: [ page ],
  data () {
    return {
      
    }
  },
  methods: {
    close()
    {
      this.close = new Howl({
        src: ['/assets/sounds/close.mp3']
      });
      this.close.play()

      this.$el.querySelector('.Shape').classList.remove('Shape_content')
      this.$emit('closeHelp')
    }
  },
  created () {
  },
  mounted () {
    setTimeout( () => {
      this.$el.querySelector('.Shape').classList.add('Shape_content')
    }, 10)

    this.$parent.$emit('toggleRender', false)

    this.open = new Howl({
      src: ['/assets/sounds/open.mp3']
    });
    this.open.play()

    this.win = new Howl({
      src: ['/assets/sounds/win.mp3']
    });
    this.win.play()

    this.$ga.page('/win')
  }
}
</script>

<style lang="stylus" scoped>

.Win

  position fixed
  top 0px
  left 0px
  z-index 10
  pointer-events auto

  @media $small

    br.desktop
      display none

  img

    width 130px

  .Page_wrapper

    max-width 860px
    position relative
    width 70%
    text-align center

    @media $large

      width 100%
      max-width 1024px

    @media $small

      width 100%

  .longuevue

    position absolute
    left 72%
    bottom 20%
    width 100px

    @media $small

      bottom 7%
      left 68%

  .ancre

    position absolute 
    left 80%
    width 120px
    bottom 13%

    @media $small

      bottom 2%
      width 80px
      left 75%

</style>
